import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import TablePagination from '@material-ui/core/TablePagination';
import { conditionalExpression } from '@babel/types';

const initialHeadCells = []


const useStyles = makeStyles({
    table: {
        minWidth: 650,
    },
});

function createData(id, transcript, count) {
    return { id, transcript, count };
}


const creatTableRow = (data, _hc) => {
    let keys = ['id']
    if (data.length >= 1) {
        keys = keys.concat(Object.keys(data[0]))
    }
    const _data = data.map((item, i) => {
        return item
    })
    return _data
}

const formateHeadCell = (data) => {
    let len = 0
    let keys = ['id']
    let _headcells = []
    if (data.length >= 1) {
        len = Object.keys(data[0]).length
        keys = keys.concat(Object.keys(data[0]))
    }
    //console.log(keys)
    for (let i = 0; i <= len; i++) {
        _headcells.push({
            id: keys[i], numeric: true, disablePadding: false, label: `${keys[i] === 'id' ? 'S.No' : keys[i]}`
        })
    }
    //console.log(_headcells)
    return _headcells;
}
export default function SimpleTable(props) {
    const classes = useStyles();
    const headCells = formateHeadCell(props.data)
    const rows = creatTableRow(props.data, headCells) || []
    //console.log(headCells)
    return (
        rows.length>=1 ?<Paper>
            <h2>{props.name}</h2>
            <TableContainer component={Paper}>
                <Table className={classes.table} aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            {headCells.map((headCell, i) => (
                                <TableCell key={headCell.id + i + headCell.label} align="left">{headCell.label}</TableCell>
                            ))}

                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rows.map(row => (
                            <TableRow key={row.name}>
                                {headCells.map((_hc,i) => 
                                    
                                        <TableCell component="th" scope="row">
                                            {_hc.id==='id'?1+i:row[_hc.id]}
                                        </TableCell>
                                    
                                )}

                                {/* <TableCell align="left">{row.transcript}</TableCell>
                                <TableCell align="left">{row.count}</TableCell> */}
                                {/* <TableCell align="right">{row.carbs}</TableCell>
                                <TableCell align="right">{row.protein}</TableCell> */}
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={100}
                rowsPerPage={10}
                page={1}
            //onChangePage={handleChangePage}
            //onChangeRowsPerPage={handleChangeRowsPerPage}
            />
        </Paper>
    : null
    );
}